import React from "react"
import styled from 'styled-components'

const Header = () => {
  return (
    <StyledHeader>
      <H1><span>Hello,</span> I'm Dominik &#128075;</H1>
      <H3>I design and code simple things.</H3>
      <H4>I love what I do.</H4>
    </StyledHeader>
  )
}

const StyledHeader = styled.header`
  ${({theme}) => theme.media.phone} {
  }
`

const H1 = styled.h1`
  position: relative;
  margin: 0 0 1px 0;
  font-weight: ${({theme}) => theme.font.semiBold};
  font-size: 42px;
  color: ${({theme}) => theme.color.black};
  z-index: 1;
  
  span::before {
    position: absolute;
    top: 26px;
    left: -5px;
    display: block;
    content: '';
    width: 118px;
    height: 23px;
    background-color: ${({theme}) => theme.color.blue};
    z-index: -1;
  }
  
  ${({theme}) => theme.media.phone} {
    
    font-size: 32px;
    
    span::before {
    width: 94px;
    height: 16px;
    top: 23px;
    }
  }
`

const H3 = styled.h3`
  margin: 0 0 1px 0;
  font-weight: ${({theme}) => theme.font.medium};
  font-size: 26px;
  color: ${({theme}) => theme.color.black};
  
  ${({theme}) => theme.media.phone} {
    font-size: 24px;
  }
`

const H4 = styled.h4`
  font-weight: ${({theme}) => theme.font.regular};
  font-size: 24px;
  color: ${({theme}) => theme.color.black};
  margin-bottom: 3px;
  
  ${({theme}) => theme.media.phone} {
    font-size: 22px;
  }
`;

export default Header
